const ENTITIES = {
    '&nbsp;': ' ',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#x27;': "'",
    '&amp;': '&',
};

/**
 * Turns stored HTML into readable plain text. Never renders HTML, so the
 * result is safe to show as a React text child (pair with pre-wrap).
 * Breaks and block ends become new lines, list items become bullets,
 * script/style blocks are dropped, every other tag is removed (its text
 * stays), and common entities are decoded once. Empty input -> ''.
 * Example: 'One<br><b>Two</b>' -> 'One\nTwo'.
 */
export const htmlToPlainText = (value) => {
    if (!value) return '';

    return `${value}`
        .replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1\s*>/gi, '')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<li\b[^>]*>/gi, '• ')
        .replace(/<\/(p|div|li|h[1-6])\s*>/gi, '\n')
        .replace(/<[^>]*>/g, '')
        .replace(
            /&(nbsp|lt|gt|quot|#39|#x27|amp);/gi,
            (entity) => ENTITIES[entity.toLowerCase()],
        )
        .replace(/\n{3,}/g, '\n\n')
        .trim();
};
